module.exports = __webpack_public_path__ + "static/media/incoming.44c5ea07.png";